import { render, staticRenderFns } from "./StakeholderResponses.vue?vue&type=template&id=5c44daf0&scoped=true&"
import script from "./StakeholderResponses.vue?vue&type=script&lang=js&"
export * from "./StakeholderResponses.vue?vue&type=script&lang=js&"
import style0 from "./StakeholderResponses.vue?vue&type=style&index=0&id=5c44daf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c44daf0",
  null
  
)

export default component.exports